import React from 'react'
import BookingRatesSection from './BookingRatesSection';
import BookingInformationSection from './BookingInformationSection';
import { SectionHeader } from '../../components/SectionElements';

function Bookings() {

    return (
        <div className='relative flex justify-evenly'>
            <div className='px-8 md:px-0 md:w-2/3 xl:w-3/5 space-y-10'>
                <section>
                    <SectionHeader title="Booking Rates" />
                    <BookingRatesSection />
                </section>
                <section>
                    <SectionHeader title="Booking Information" />
                    <BookingInformationSection />
                </section>
            </div>
        </div >
    )
}

export default Bookings;